import { FC } from 'react';

import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActions from '@mui/material/CardActions';
import Skeleton from '@mui/material/Skeleton';
import GridCard from 'components/GridCard';

const DashboardFlightsCardSkeleton: FC = () => (
  <GridCard>
    <CardContent>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        <Skeleton width={200} />
      </Typography>

      <Typography variant="h5" component="div" sx={{ mb: 2 }}>
        <Skeleton width={50} />
      </Typography>

      <Typography variant="body2">
        <Skeleton width={300} />
      </Typography>
    </CardContent>

    <CardActions>
      <Skeleton width={100} height={31} />
    </CardActions>
  </GridCard>
);

export default DashboardFlightsCardSkeleton;
